import React from "react";
import ViewProductSalesOrderPage from "pages/TagsSearchPage/OrderListing/SalesListing/View/ViewSalesOrderPage";
import ViewServiceSalesOrderPage from "pages/TagsSearchPage/OrderListing/ServiceListing/View/ViewServiceSalesOrderPage";

interface SalesOrderViewComponentProps {
  id: string;
  type: "product" | "service";
}

export const SalesOrderViewComponent: React.FC<SalesOrderViewComponentProps> = ({
  id,
  type,
}) => {
  return type === "product" ? (
    <ViewProductSalesOrderPage id={id} />
  ) : (
    <ViewServiceSalesOrderPage id={id} />
  );
};
